import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Archive, ArchiveRestore, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { apiError } from "@/lib/network";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

const LABEL = { odc: "ODC", odp: "ODP", otb: "OTB", server: "SERVER", fdt: "FDT" };

// Arsip/Pulihkan ODC/ODP khusus Admin; backend tetap memvalidasi.
export function ArchiveInfraButton({ kind, item, me, onDone, iconOnly = false, tid: btnTid }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [chk, setChk] = useState(null);
  if (!me?.is_admin || !item) return null;
  const label = LABEL[kind];
  const restore = !!item.archived;
  const Icon = restore ? ArchiveRestore : Archive;
  const verb = restore ? "Pulihkan" : "Arsipkan";
  const openDlg = () => {
    setChk(null); setOpen(true);
    if (!restore) api.get(`/network/${kind}/${item.id}/delete-check`).then((r) => setChk(r.data)).catch(() => setChk({ error: true }));
  };
  const blocked = !restore && (!chk || chk.error || chk.archive_blockers.length > 0);
  const run = async () => {
    setBusy(true);
    try {
      await api.post(`/network/${kind}/${item.id}/${restore ? "restore" : "archive"}`);
      toast.success(`${label} ${item.kode} ${restore ? "dipulihkan (status NONAKTIF)" : "diarsipkan"}`);
      setOpen(false);
      onDone?.(item);
    } catch (err) {
      toast.error(apiError(err), { duration: 8000 });
    } finally {
      setBusy(false);
    }
  };
  const tid = `${kind}-${restore ? "restore" : "archive"}`;
  return (
    <>
      {iconOnly
        ? <Button size="icon" variant="ghost" onClick={openDlg} title={`${verb} ${label}`} data-testid={btnTid || `${tid}-${item.kode}`}><Icon className="h-4 w-4 text-[#B45309]" /></Button>
        : <Button size="sm" variant="outline" onClick={openDlg} data-testid={`${tid}-btn`}><Icon className="mr-1 h-3.5 w-3.5" />{verb}</Button>}
      <AlertDialog open={open} onOpenChange={(v) => !busy && setOpen(v)}>
        <AlertDialogContent data-testid={`${tid}-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle>{verb} {label} {item.kode}?</AlertDialogTitle>
            <AlertDialogDescription>
              {restore
                ? `${label} akan kembali tampil di daftar dengan status NONAKTIF. Ubah ke AKTIF lewat Edit bila akan dipakai lagi.`
                : `${label} akan disembunyikan dari daftar aktif, peta, dan pilihan relasi baru, serta diubah ke NONAKTIF. Relasi dan riwayat tidak diubah; kode/nama tetap tampil di riwayat.`}
            </AlertDialogDescription>
            {!restore && !chk && <p className="text-xs text-[#6B7280]">Memeriksa ketergantungan…</p>}
            {!restore && chk?.error && <p className="text-xs text-[#B91C1C]">Gagal memeriksa ketergantungan. Coba lagi.</p>}
            {!restore && chk?.archive_blockers?.length > 0 && (
              <div className="rounded-md border border-[#FCA5A5] bg-[#FEF2F2] p-2 text-xs text-[#B91C1C]" role="alert" data-testid="archive-check-active">
                <b>Tidak dapat diarsipkan — masih ada ketergantungan aktif:</b> {chk.archive_blockers.join("; ")}.</div>)}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy} data-testid={`${tid}-cancel`}>Batal</AlertDialogCancel>
            <Button disabled={busy || blocked} onClick={run} data-testid={`${tid}-confirm`}>
              {busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}{verb}</Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
